<template>
  <div class="basic">
    <Upload :avatarUrl="personal.avatarUrl" @uploadSuccess="uploadSuccess" />
    <div class="member-name">
      <div v-if="!isEdit">
        <span class="name" style=""
          >{{ $t('profile.name') }} {{ personal.userName }}</span
        >
        <img
          class="name-edit"
          src="@/common/image/profile/profile-edit.svg"
          alt=""
          @click="edit"
        />
      </div>
      <el-input
        v-else
        v-model="inputName"
        @blur="nameChange"
        ref="updateNameRef"
        autofocus
      />
    </div>
    <div class="member-list">
      <span class="title">{{ $t('profile.memberAccount') }}</span>
      <div class="account">
        <el-input disabled v-model="personal.email" />
      </div>
    </div>
    <div class="member-list">
      <span class="title">{{ $t('profile.gender') }}</span>
      <div class="gender">
        <el-radio-group @change="genderChange">
          <el-radio v-model="radio" label="0" size="large">{{
            $t('profile.female')
          }}</el-radio>
          <el-radio v-model="radio" label="1" size="large">{{
            $t('profile.male')
          }}</el-radio>
          <el-radio v-model="radio" label="2" size="large">{{
            $t('profile.secret')
          }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="member-list">
      <span class="title">{{ $t('profile.birth') }}</span>
      <div class="select">
        <el-select
          v-model="birthDate"
          @change="birthChange"
          :placeholder="$t('profile.pleaseSelect')"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue'
import { updateName } from '@/api/profile'
import { ElMessage } from 'element-plus'
import Upload from '@/components/profile/upload.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  props: {
    userInfoList: {
      type: Object,
      default: () => ({}),
    },
    userName: {
      type: String,
      default: '',
    },
  },

  components: { Upload },
  setup(props, { emit }) {
    const { t } = useI18n()
    const isEdit = ref(false)
    const showName = computed(() => props.userName)
    const personal = computed(() => props.userInfoList)
    const inputName = ref<string>('')
    const radio = ref<string>('')
    const birthDate = ref<string>('')
    const updateNameRef = ref<HTMLInputElement>()
    const options = [
      {
        value: '0',
        label: t('profile.year50s'),
      },
      {
        value: '1',
        label: t('profile.year60s'),
      },
      {
        value: '2',
        label: t('profile.year70s'),
      },
      {
        value: '3',
        label: t('profile.year80s'),
      },
      {
        value: '4',
        label: t('profile.year85s'),
      },
      {
        value: '5',
        label: t('profile.year90s'),
      },
      {
        value: '6',
        label: t('profile.year95s'),
      },
      {
        value: '7',
        label: t('profile.year00s'),
      },
      {
        value: '8',
        label: t('profile.year05s'),
      },
    ]
    const edit = () => {
      isEdit.value = true
      inputName.value = showName.value
      setTimeout(() => {
        // autofocus并不是每次都有效，只有第一次有效，后面不能autofocus，所以手动focus
        updateNameRef.value?.focus()
      }, 200)
    }

    const nameChange = async () => {
      if (inputName.value === showName.value) {
        isEdit.value = false
        return
      }
      if (inputName.value && personal.value.userName.length <= 255) {
        const res = await updateName(inputName.value)
        if (res.status) {
          ElMessage({
            message: t('profile.updateSuccess'),
            type: 'success',
          })
          emit('uploadSuccess')
        }
      }
      isEdit.value = false
    }

    const genderChange = () => {
      personal.value.gender = parseInt(radio.value)
    }
    const birthChange = () => {
      bitrhTrasnfer(parseInt(birthDate.value))
    }
    const bitrhTrasnfer = (value: number) => {
      switch (value) {
        case 0:
          birthDate.value = '0'
          personal.value.ageClass = 0
          break
        case 1:
          birthDate.value = '1'
          personal.value.ageClass = 1
          break
        case 2:
          birthDate.value = '2'
          personal.value.ageClass = 2
          break
        case 3:
          birthDate.value = '3'
          personal.value.ageClass = 3
          break
        case 4:
          birthDate.value = '4'
          personal.value.ageClass = 4
          break
        case 5:
          birthDate.value = '5'
          personal.value.ageClass = 5
          break
        case 6:
          birthDate.value = '6'
          personal.value.ageClass = 6
          break
        case 7:
          birthDate.value = '7'
          personal.value.ageClass = 7
          break
        case 8:
          birthDate.value = '8'
          personal.value.ageClass = 8
          break
        default:
          birthDate.value = ''
          personal.value.ageClass = null
      }
    }
    const uploadSuccess = () => {
      emit('uploadSuccess')
    }

    onMounted(() => {
      radio.value = `${personal.value.gender}`
      bitrhTrasnfer(personal.value.ageClass)
    })
    return {
      isEdit,
      edit,
      radio,
      birthDate,
      options,
      genderChange,
      birthChange,
      nameChange,
      uploadSuccess,
      updateNameRef,
      showName,
      inputName,
      personal,
    }
  },
})
</script>
<style lang="less" scoped>
.basic {
  text-align: center;
  margin-top: 30px;
  .profile-bird {
    width: 100px;
  }
  .member-name {
    .name {
      height: 30px;
      line-height: 30px;
      margin-top: 5px;
      font-size: 18px;
      display: inline-block;
      margin-top: 10px;
      height: 40px;
      line-height: 40px;
    }
    .name-edit {
      width: 14px;
      margin-top: 10px;
      margin-left: 10px;
      cursor: pointer;
    }
    .el-input {
      width: 200px;
      /deep/.el-input__inner {
        height: 40px;
        margin-top: 10px;
      }
    }
  }
  .member-list {
    display: flex;
    flex-flow: column;
    margin-top: 20px;
    .title {
      font-size: 18px;
      margin-left: 35px;
      margin-bottom: 5px;
      margin-right: auto;
    }
    span {
      font-size: 18px;
      margin-right: auto;
      display: inline-block;
      height: 45px;
      line-height: 45px;
    }
    .account,
    .select {
      margin: 0px auto 0px 20px;
    }
    .gender {
      margin: 0px auto 0px 50px;
      /deep/.el-radio__label {
        font-size: 16px;
      }
      /deep/.el-radio__inner {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        border-radius: 1px;
      }
      /deep/.el-radio__inner::after {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        content: '✓';
        color: #fff;
        font-weight: 700;
        background-color: #0ca1bd;
        border-radius: 1px;
      }
      /deep/.el-radio__label {
        color: #303133;
      }
    }
    /deep/.el-input {
      width: 668px;
      margin-left: 15px;
    }
  }
}
</style>

